import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import NoMatch from "./views/NoMatch";
import Search from "./views/Search";
import ForgotOrderNo from "./views/Search/containers/ForgotOrderNo";
import Order from "./views/Order";

export default class App extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact path="/404" component={NoMatch} />

                <Route exact path="/embedded/search" component={Search} />

                <Route exact path="/embedded/search/forgot-order-no" component={ForgotOrderNo} />

                <Route exact path="/embedded/orders/:order_id" component={Order} />

                <Redirect to="/404" />
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.jsx